// extracted by mini-css-extract-plugin
export default {"Modes":"Modes_Modes__XpeY0","Banner":"Modes_Banner__aLUb2","BannerHidden":"Modes_BannerHidden__4yeaN","BannerVisible":"Modes_BannerVisible__SL9oF"};